import { EntityApiDefinitionCard } from '@backstage/plugin-api-docs';

export const ApiDefinitionTab = () => <EntityApiDefinitionCard />;
